import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.58117 1.4991C8.40782 0.827447 9.59218 0.827447 10.4188 1.4991L14.9188 5.15536C15.4447 5.58261 15.75 6.22407 15.75 6.90161V13.5002C15.75 14.7428 14.7426 15.7502 13.5 15.7502H12V11.25C12 10.0074 10.9926 9 9.75 9H8.25C7.00736 9 6 10.0074 6 11.25V15.75L4.5 15.7502C3.25736 15.7502 2.25 14.7428 2.25 13.5002V6.90161C2.25 6.22407 2.55532 5.58261 3.08117 5.15536L7.58117 1.4991Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.5 15.7502H10.5V11.25C10.5 10.8358 10.1642 10.5 9.75 10.5H8.25C7.83579 10.5 7.5 10.8358 7.5 11.25V15.7502Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }